
import { WorldCity } from '../types';

// Segunda expansión de India - 50 ciudades adicionales
export const indiaAdditionalCities2: WorldCity[] = [
  { name: 'Moga', slug: 'moga', population: 159897 },
  { name: 'Abohar', slug: 'abohar', population: 145302 },
  { name: 'Malerkotla', slug: 'malerkotla', population: 135424 },
  { name: 'Khanna', slug: 'khanna', population: 128137 },
  { name: 'Phagwara', slug: 'phagwara', population: 100705 },
  { name: 'Muktsar', slug: 'muktsar', population: 94804 },
  { name: 'Barnala', slug: 'barnala', population: 116449 },
  { name: 'Faridkot', slug: 'faridkot', population: 79815 },
  { name: 'Kapurthala', slug: 'kapurthala', population: 99463 },
  { name: 'Rajpura', slug: 'rajpura', population: 99752 },
  { name: 'Nabha', slug: 'nabha', population: 67972 },
  { name: 'Malout', slug: 'malout', population: 107643 },
  { name: 'Jagraon', slug: 'jagraon', population: 66032 },
  { name: 'Sunam', slug: 'sunam', population: 59304 },
  { name: 'Dhuri', slug: 'dhuri', population: 56189 },
  { name: 'Gobindgarh', slug: 'gobindgarh', population: 61449 },
  { name: 'Khararl', slug: 'kharar', population: 54074 },
  { name: 'Patti', slug: 'patti', population: 150000 },
  { name: 'Dinanagar', slug: 'dinanagar', population: 25850 },
  { name: 'Longowal', slug: 'longowal', population: 16451 },
  { name: 'Urmar Tanda', slug: 'urmar-tanda', population: 19549 },
  { name: 'Nakodar', slug: 'nakodar', population: 49722 },
  { name: 'Jalandhar Cantt', slug: 'jalandhar-cantt', population: 38260 },
  { name: 'Phillaur', slug: 'phillaur', population: 26117 },
  { name: 'Nurmahal', slug: 'nurmahal', population: 19645 },
  { name: 'Narangwal', slug: 'narangwal', population: 12500 },
  { name: 'Shahkot', slug: 'shahkot', population: 18831 },
  { name: 'Sultanpur Lodhi', slug: 'sultanpur-lodhi', population: 24440 },
  { name: 'Doraha', slug: 'doraha', population: 18906 },
  { name: 'Bhogpur', slug: 'bhogpur', population: 14726 },
  { name: 'Kartarpur', slug: 'kartarpur', population: 23085 },
  { name: 'Raikot', slug: 'raikot', population: 37736 },
  { name: 'Sahnewal', slug: 'sahnewal', population: 25537 },
  { name: 'Samrala', slug: 'samrala', population: 17890 },
  { name: 'Dehlon', slug: 'dehlon', population: 14932 },
  { name: 'Payal', slug: 'payal', population: 19736 },
  { name: 'Machhiwara', slug: 'machhiwara', population: 15105 },
  { name: 'Khemkaran', slug: 'khemkaran', population: 7011 },
  { name: 'Bhikhiwind', slug: 'bhikhiwind', population: 14406 },
  { name: 'Pindigheb', slug: 'pindigheb', population: 8500 },
  { name: 'Jandiala', slug: 'jandiala', population: 12900 },
  { name: 'Mahilpur', slug: 'mahilpur', population: 19766 },
  { name: 'Dasuya', slug: 'dasuya', population: 33855 },
  { name: 'Mukerian', slug: 'mukerian', population: 32481 },
  { name: 'Talwara', slug: 'talwara', population: 17890 },
  { name: 'Dina Nagar', slug: 'dina-nagar', population: 25850 },
  { name: 'Fatehgarh Churian', slug: 'fatehgarh-churian', population: 19500 },
  { name: 'Dera Baba Nanak', slug: 'dera-baba-nanak', population: 36986 },
  { name: 'Batala', slug: 'batala', population: 156400 },
  { name: 'Sri Hargobindpur', slug: 'sri-hargobindpur', population: 18831 }
];
